import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchInventoryTypes } from "../../actions/records";
import Swal from "sweetalert2";
import colors from "../../constants/colors";
import DropDown from "../widgets/dropdownMultiple";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { getComponentByanotherComponentId, getLotCodeString, getTotalSelected } from "../../utils";
import LotsByLocation from "../widgets/LotsByLocation";

class SearchIngredientsByLot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.initial ? props.initial : "",
            searchText: typeof props.initial == "string" ? props.initial : typeof props.initial == "object" ? getLotCodeString(props.initial) : "",
            height: 30,
            items: [],
            wasEdited: false,
            options: props.options ? props.options : [],
            lotsSelected: props.initial ? props.initial : [],
            openList: false,
            showLotsByLocation: false,
            minorAmount: true
        };
        this.textInputRef = createRef(null);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isRecipe, defaultLabel, position, isInventoryReceivingForm } = this.props;
        if (nextProps.initial != this.props.initial) {
            if (this.isReceivingLotCode(defaultLabel) && isInventoryReceivingForm) {
                this.setState({ searchText: getLotCodeString(nextProps.initial, position) });
                this.setState({ lotsSelected: nextProps.initial });
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.options != this.props.options) {
            this.setState({ options: nextProps.options });
        }
        if (nextProps.reset != this.props.reset) {
            if (defaultLabel == "lotcode" && isRecipe) {
                this.setState({ lotsSelected: nextProps.initial });
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch) {
            this.setState({ wasEdited: false });
        }
    }
    searchItems(val) {
        const { type, searchBy, isRecipe, onSelectItem, options } = this.props;
        const { openList } = this.state;
        if (val) {
            if (searchBy == 'lot') {
                if (isRecipe) {
                    if (options) {
                        var filtered = options.filter((option) => {
                            if (option?.lot) {
                                return option.lot.toLowerCase().includes(val.toLowerCase());
                            }
                        });
                        this.setState({ options: filtered, openList: filtered?.length <= 0 ? false : true }, () => {
                            if (filtered?.length <= 0) {
                                onSelectItem(val, true);
                            }
                        });
                    }
                }
            }
        } else this.setState({ items: [], options: this.props.options });
    }
    alert() {
        Swal.fire({
            text: "This item was already selected, please choose another one",
            confirmButtonText: "Ok",
            confirmButtonColor: colors.orange,
            backdrop: false
        });
    }
    onSelectedItemsChange(lotsSelected) {
        const { onSelectItem, initial } = this.props;
        this.setState({ lotsSelected });
        if (typeof initial == "string") {
            this.setState({ searchText: "" });
        }
        onSelectItem(lotsSelected, true);
    }
    alertConfirm(msg, conf) {
        Swal.fire({
            text: msg,
            confirmButtonText: conf,
            confirmButtonColor: '#0B4DA0',
            backdrop: false
        });
    }
    isReceivingLotCode(defaultLabel){
        return defaultLabel == "lotcode" || defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip";
    }
    render() {
        const { value, items, wasEdited, lotsSelected, options, openList, searchText, showLotsByLocation } = this.state;
        const { defaultComponent, onSelectItem, searchBy, itemInvoice_id, submission, position, isRecipe, isInvoice, isInventoryTransfer, width, openDropDown, backgroundColor, 
            isLast, isDropDownOpened, resetDropDown, filllocationFromLotsView, isInventoryForm, units, amount, id, ingredientName, onChange, components, minorAmount, requiredAmount, isInventoryReceivingForm, defaultLabel, isShipmentLog } = this.props;
        return <View>
            {((isInventoryForm || isInventoryReceivingForm) && showLotsByLocation) && <LotsByLocation units={units} amount={amount} lotsSelected={lotsSelected} options={options ? options : []} id={id} position={position} name={ingredientName} onBack={(editQty, totalSelected, minorAmount) => {
                this.setState({ showLotsByLocation: false, minorAmount });
                if(!isRecipe && onChange && editQty){
                    var quantityComponent = isShipmentLog ? defaultLabel == "lotcode_finished" ? getComponentByanotherComponentId(id, "quantityFinishedGoods", components) : defaultLabel == "lotcode_wip" ? getComponentByanotherComponentId(id, "quantityWIP", components) : getComponentByanotherComponentId(id, "quantityIngredient", components) : getComponentByanotherComponentId(id, "quantity", components);
                    if(quantityComponent)onChange(quantityComponent.id, totalSelected)
                }
            }} placeholder={"Search by lot code"} onSelect={(selected, location) => {
                this.onSelectedItemsChange(selected);
                if(isRecipe && filllocationFromLotsView)filllocationFromLotsView(location)
            }} components={components} openAlert={(value) => this.setState({ showLotsByLocation: !value })} requiredAmount={requiredAmount} isInventoryType={defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip"}/>}
            {
                isInventoryReceivingForm && searchBy == 'lot' ?
                    <View style={{...styles.inputContainer,
                        borderRadius: isInventoryReceivingForm ? 20 : 5,
                        backgroundColor: isInventoryReceivingForm ? minorAmount ? colors.quit : colors.primary : 'none'
                    }}>
                        <TextInput
                            ref={this.textInputRef}
                            value={searchText}
                            editable={!defaultComponent}
                            onContentSizeChange={(event) => {
                                if (event.nativeEvent.contentSize.height == 0) {
                                    if (this.props.placeholder == '') {
                                        this.setState({ height: 30 })
                                    }
                                    this.setState({ height: event.nativeEvent.contentSize.height });
                                } else {
                                    setTimeout(() => {
                                        this.setState({ height: event.nativeEvent.contentSize.height });
                                    }, 5)
                                }
                            }}
                            onFocus={()=> {
                                if((isInventoryForm || isInventoryReceivingForm) && (typeof options == "object" && options?.length > 0)){
                                    this.setState({ showLotsByLocation: true }, () =>{
                                        if (this.textInputRef.current) {
                                          this.textInputRef.current.blur();
                                        }
                                    });
                                }
                            }}
                            style={{
                                ...styles.input,
                                borderRadius: isInventoryReceivingForm ? 20 : 5,
                                borderWidth: ((isInventoryReceivingForm && width)) ? 0 : 1,
                                color: isInventoryReceivingForm ? 'white' : "#424242",
                                fontFamily: "Roboto",
                                fontSize: isInventoryReceivingForm ? 14 : 20,
                                fontWeight: "400",
                                padding: 5,
                                height: this.state.height,
                                fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                                overflow: 'hidden',
                                textAlign: isInventoryReceivingForm ? 'center' : 'left',
                                backgroundColor: isInventoryReceivingForm ? minorAmount ? colors.quit : colors.primary : 'none',
                                flex: isInventoryReceivingForm && lotsSelected.length ? 9 : 12,
                                cursor: isInventoryReceivingForm ? 'pointer' : 'auto',
                            }}
                            multiline={true}
                            placeholder={options?.length > 0 && !isInventoryReceivingForm ? "Enter a lot to search" : ""}
                            placeholderTextColor={'rgb(0, 47, 108)'}
                            onChangeText={(val) => {
                                if (val == '' && this.props.placeholder == '') {
                                    this.setState({ searchText: val, height: 30, wasEdited: true });
                                } else {
                                    this.setState({ searchText: val, wasEdited: true });
                                }
                                this.searchItems(val);
                            }}
                        /> 
                        {
                            isInventoryReceivingForm && lotsSelected?.length > 1 && <Text style={styles.lotsSelectedViewTxt}>+{lotsSelected?.length - 1}</Text>
                        }
                    </View>
                    : null
            }
            {
                !isInventoryReceivingForm && searchBy == 'lot' && (options?.length > 0 || (typeof lotsSelected == "object" && lotsSelected?.length > 0)) ?
                    <DropDown
                        initialOption={lotsSelected}
                        updated={lotsSelected}
                        reset={this.props.reset}
                        options={options}
                        openList={openList}
                        defaultComponent={defaultComponent}
                        defaultLabel={"No Lot"}
                        allLabel={"FIFO"}
                        onSelect={(lots) => {
                            this.onSelectedItemsChange(lots);
                        }}
                        recipeStyle={isRecipe}
                        isRecipe={false}
                        width={width}
                        openDropDown={openDropDown}
                        backgroundColor={backgroundColor}
                        isLast={isLast}
                        isDropDownOpened={isDropDownOpened}
                        resetDropDown={resetDropDown}
                    />
                    : null
            }
            {
                items?.length > 0 &&
                items.map((item, idx) => {
                    return <div key={idx} style={styles.row}>
                        <div>
                            {searchBy == 'lot' ? item?.lot : item?.item}
                        </div>
                        <div>
                            <TouchableOpacity style={styles.rowBtn} onPress={() => {
                                if (searchBy == 'lot') {
                                    onSelectItem(item, true);
                                } else {
                                    if (submission[itemInvoice_id]) {
                                        var exists = submission[itemInvoice_id].filter(sub => sub == item?.lot);
                                        if (exists.length > 0 && submission[itemInvoice_id][position] != item?.lot) {
                                            this.alert();
                                            return;
                                        }
                                    }
                                    var newItem = item;
                                    newItem.lotSelected = ["default_lot"];
                                    onSelectItem(item, true);
                                }
                                this.setState({ items: [], value: searchBy == 'lot' ? item?.lot : item?.item, wasEdited: false });
                            }}><Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text>
                            </TouchableOpacity>
                        </div>
                    </div>
                })
            }
            {
                (searchText && options?.length <= 0 && wasEdited) ? <View><Text>No lots were found</Text></View> : null
            }
        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
}), (dispatch, props) => ({
    searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
}))(SearchIngredientsByLot);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        //padding: 5,
        width: "100%",
        gridTemplateColumns: "90% 10%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: {
        fontSize: 20,
        color: colors.selectSearch
    },
    inputContainer:{
        flexDirection: 'row',
    },
    lotsSelectedView: { 
        flex: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.primary,
        color: 'white',
        borderRadius: 20,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
    },
    lotsSelectedViewTxt:{
        color: 'white',
        borderWidth: 1,
        borderRadius: 5,
        padding: 2,
        borderColor: 'white',
        fontSize: 12,
        height: 20,
        marginRight: 10,
        marginTop: 4
    },
});